export default "__VITE_ASSET__mTeKDbUj__"